import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import Layout from '../_layout/layout';
import SEO from '../_layout/seo';
import BreadCrumbs from '../_components/shares/breadcrumbs';

// import SidebarExternalArticlesLatest from '../_components/shares/sidebar-external-articles-latest';
import JournalFeaturedPosts from '../_components/shares/journal-featured-posts';
import HomeBenefits from '../_components/homepage/benefits';

const NewsArticlePage = ({ data }) => {
  const article = data.contentfulArticle;
  const bclinks = [
    {
      name: 'ニュース',
      to: '/news/',
    },
    {
      name: article.title,
      to: `/article/${article.slug}/`,
    },
  ];
  return (
    <Layout>
      <SEO
        title={`${article.title} | 働き方情報 Clarity（クラリティ）`}
        ogp={article.heroImage.fluid.src}
        url={`/article/${article.slug}/`}
      />
      <BreadCrumbs bclinks={bclinks} />

      {/*  */}
      <div className="container-fluid px-0 max-1100">
        <div className="row mx-0">
          {/*  */}
          <div className="col-lg-9 col-12 news-article-page">
            <Img fluid={article.heroImage.fluid} />

            <div className="article-meta row mr-0 ml-0">
              <span className="article-date pl-0">{article.date}</span>
            </div>

            <h1 className="news-article-page-title">{article.title}</h1>

            <div className="article-content">
              <ReactMarkdown
                className="article-text"
                escapeHtml={false}
                source={article.content.content}
              />
            </div>
          </div>

          {/*  */}
          <div className="col-lg-3 col-12 sidebar-wrapper">
            {/* benefits list */}
            <div className="sidebar-wrapper-content">
              <div className="sidebar-wrapper-title">
                <span className="text-green">働き方情報をみる</span>
              </div>
              <HomeBenefits />
            </div>
            <JournalFeaturedPosts />
            {/* <SidebarExternalArticlesLatest /> */}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query($slug: String!) {
    contentfulArticle(slug: { eq: $slug }) {
      title
      date
      slug
      heroImage {
        fluid(maxWidth: 740) {
          ...GatsbyContentfulFluid
        }
      }
      content {
        content
      }
    }
  }
`;

export default NewsArticlePage;
